import axios from "axios";

export default axios.create({
  baseURL: "https://kewgreen.wegosecure.com/api/",
  //baseURL: 'https://89b7d383c65e.ngrok.app/api/',
  headers: {
    "Content-type": "application/json",
  },
});
